define([
	"dojo/_base/declare",
	"Apparel/NewStyleForm"
], function(declare,NewStyleForm) {

	return declare(NewStyleForm, {
		getValueForField: function(/*Field*/field, /*Node?*/node) {
			if (field.m_id === "Collection") {
				field._bUpdated = true;
			}

			return this.inherited(arguments);
		},

		canEnableButton: function(/*Button*/button, /*String*/idAction) {
			var f = this.getField("CandidateQuantity");
			return (idAction != "Save_Go" || !f || f.getValue() == "" || f.getValue() == 1);
		}
	});
});
